angular.module('ufcw')

.constant('EnvConfig', {
  "URL_API"			: "https://api-agenda.nacionalclubsocial.uy/",
  "URL_IMAGES"  : "https://squalus-public-production.s3.us-east-2.amazonaws.com/agenda/nacional/",
  "URL_FILES"  : "https://squalus-public-production.s3.us-east-2.amazonaws.com/agenda/nacional/",
  "COMPANY_ID"  : "1",
  "SIGNIN_ENABLED":true,
  "footer_app_name":"NACIONAL CLUB SOCIAL",
  "footer_email":"hola@nacionalclubsocial.uy",
  "footer_facebook":"https://www.facebook.com/nacionalclubsocial/",
  "footer_twitter":"https://twitter.com/nacionalcsocial",
  "footer_instagram":"https://www.instagram.com/nacionalclubsocial/",
  "footer_youtube":"https://www.youtube.com/channel/UCN4JBah1YUV9Qd8iQmjNq3Q",
  "show_aviso_covid":false,
  "show_cuponeras":false,
  "show_reglas":false,
  "signup_nrosocio":false,
  "signup_dob":true,
  "projectname":"nacional",
  "show_payment_expiration": false,
  "show_carnet_expiration": true
});
